import React, { useEffect, useState } from 'react';
import Modal from '../../_ui/Modal/Modal';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import Button from '../../_ui/Button/Button';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import DoneIcon from '@material-ui/icons/Done';
import { Color } from '../ThemeProvider/ThemeStyle';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import MuiSelect from '@material-ui/core/Select';
import moment from 'moment';
import DatePicker from '../../_ui/DatePicker/DatePicker';
import { Switch } from '@material-ui/core';
import { ImportContainer } from './ReportStyle';
import ShowDocument from './ShowDocument';
import Notice from '../../utils/Notice';
import { CONTINGENT_STATUS, ROLES } from '../../_helpers/Constants';

const defaultPeriod = { start: null, end: null };
const expelledDocumentReasons = ['REFERENCE', 'LEAVE_APPLICATION'];

export default function ModalReportCard(modalData) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [causeCode, setCauseCode] = useState(modalData.data?.absenceReason);
  const [activeCode, setActiveCode] = useState(modalData.data?.absenceReason);
  const [isErrorCause, setIsErrorCause] = useState(false);
  const [period, setPeriod] = useState(defaultPeriod);
  const [isErrorDate, setIsErrorDate] = useState(false);
  const [file, setFile] = useState({});
  const date = new Date();
  const logDateMoment = moment(modalData.data?.logDate);
  const isExpelled = modalData.data?.contingentStatus === CONTINGENT_STATUS.EXPELLED;
  const isCurrentOrPrevMonth =
    Boolean(modalData.data?.logDate) &&
    logDateMoment.isValid() &&
    (logDateMoment.isSame(moment(), 'month') ||
      logDateMoment.isSame(moment().subtract(1, 'month'), 'month'));
  const isExpelledDocumentOnly =
    isExpelled &&
    !modalData.data?.isHead &&
    Boolean(modalData.isEdit || modalData.canUploadPastFile) &&
    expelledDocumentReasons.includes(modalData.data?.absenceReason) &&
    isCurrentOrPrevMonth;
  const canEditCause = Boolean(modalData.isEdit) && !isExpelled;
  const canUploadPastFile =
    Boolean(modalData.canUploadPastFile) && !isExpelled && Boolean(modalData.data?.absenceReason);
  const canEditPeriod = canEditCause || canUploadPastFile;
  const canUploadFile = canEditPeriod || isExpelledDocumentOnly;
  const canSave = isExpelledDocumentOnly ? Boolean(file.name) : canEditPeriod;
  const save = () => {
    if (causeCode) {
      if (!isExpelledDocumentOnly && causeCode === 'LEAVE_APPLICATION' && !(period.start && period.end)) {
        setIsErrorDate(true);
      } else {
        dispatch(modalData.saveCause({
          causeCode,
          userID: modalData.data?.userID,
          logDate: modalData.data.logDate,
          close: modalData.close,
          period: isExpelledDocumentOnly ? defaultPeriod : period,
          file: file,
          activeCode
        }))
      }
    } else {
      setIsErrorCause(true)
    }
  }

  const saveTechnicalError = () => {
    if (causeCode) {
      if (causeCode === 'TECHNICAL_ERROR' && !(period.start && period.end)) {
        setIsErrorDate(true);
      } else {
        dispatch(modalData.saveTechnicalError({
          logDate: modalData.data.logDate,
          close: modalData.close,
          period,
          file: file,
          filter: modalData.filter
        }))
      }
    } else {
      setIsErrorCause(true)
    }
  }

  useEffect(() => {
    if (modalData.data.isHead) {
      setCauseCode(modalData.data.cause)
    }
    if (!modalData.data.isHead) {
      setPeriod({...period, start: modalData.data.logDate })
    }
  }, [modalData.data]);

  return (
    <Modal
      title={modalData.data.isVisited ? `${t('pageReport_arrivalDate') + ': ' + moment(modalData.data.logDate).format('DD.MM.YYYY')}` : `${t('pageReport_reportModalTitle') + ': ' + moment(modalData.data.logDate).format('DD.MM.YYYY')}`}
      open
      onClose={modalData.close}
    >
      <DialogContent>
        {
          modalData.data.isVisited === false &&
          <>
            <Box className='flex items-center'>
              <Typography children={t('pageReport_reportCause')} style={{width: '50%'}} />
              <Box
                style={{
                  width: '100%',
                  maxWidth: '100%',
                }}
              >
                <FormControl fullWidth>
                  <MuiSelect value={causeCode} error={isErrorCause} disabled={!canEditCause || modalData.data.isHead}>
                    {
                      modalData.cause.map((item) => {
                        return <MenuItem
                          value={item.code}
                          onClick={() => {
                            setCauseCode(item.code)
                            setActiveCode(item.code)
                            setIsErrorCause(false)
                          }}
                          disabled={item.code === 'TECHNICAL_ERROR'}
                          key={item.code}
                        >
                          {item[`${i18n.language}_name`]}
                        </MenuItem>
                      })
                    }
                  </MuiSelect>
                  {isErrorCause && <FormHelperText error>{t('pageReport_requiredField')}</FormHelperText>}
                </FormControl>
              </Box>
            </Box>
              <Box className='flex items-center'>
                <Typography children={'Дата'} style={{width: '50%'}} />
                <Box
                  style={{
                    width: '100%',
                    maxWidth: '100%',
                  }}
                >
                  <Box
                    style={{
                      display: 'flex',
                      gap: '5px'
                    }}
                  >
                    <DatePicker
                      lang={i18n.language}
                      withoutForm
                      value={period.start}
                      onChange={start => setPeriod({ ...period, start })}
                      disabled={!canEditPeriod}
                    />
                    <DatePicker
                      lang={i18n.language}
                      disabled={!period.start || !canEditPeriod}
                      withoutForm
                      minDate={period.start}
                      maxDate={modalData.data.isHead && `${date.getFullYear()}-${date.getMonth()+1}-${ date.getDate()}T23:59:00`}
                      value={period.end}
                      onChange={end => setPeriod({ ...period, end })}
                    />
                  </Box>
                  {isErrorDate && <FormHelperText error>{t('pageReport_requiredStartEndDate')}</FormHelperText>}
                </Box>
              </Box>
            {
              (modalData.data.id && causeCode) &&
              <Box className='flex items-center'>
                <Typography children={t('pageReport_reportCauseCancel')} style={{width: '50%'}} />
                <Box
                  style={{
                    width: '100%',
                    maxWidth: '100%',
                  }}
                >
                  <Switch
                    onChange={() => {
                      setCauseCode('REMOVE_ABSENCE_REASON')
                    }}
                    disabled={!canEditCause}
                    color="primary"
                  />
                </Box>
              </Box> 
            }
            <Box className="flex items-center">
              <Typography children={t('pageReport_reportConfirmationDocument')} style={{ width: '50%' }} />
              <ImportContainer>
                <div id="file-name">{file.name}</div>
                <input
                  disabled={!canUploadFile}
                  id="contained-button-file"
                  type="file"
                  className="display-none"
                  required
                  accept="image/jpeg,image/jpg,image/png,application/pdf"
                  onChange={({ target }) => {
                    if (target.files[0]) {
                      if (['image/jpeg','image/jpg','image/png', 'application/pdf'].includes(target.files[0].type)) {
                        setFile(target.files[0]);
                      } else {
                        Notice.warning(t('pageReport_formatIsNotSupported'));
                      }
                    }
                  }}
                />
                <label htmlFor="contained-button-file">
                  <Button
                    variant="contained"
                    text={t('administrationPage_choose')}
                    component="span"
                  />
                </label>
              </ImportContainer>
            </Box>
            <ShowDocument data = {modalData.data} />
            <Box className="flex justify-end pt2">
              <Button
                color="primary"
                style={{ backgroundColor: Color.bgColorSuccess }}
                loading={modalData?.loadingSave}
                icon={<DoneIcon fontSize="small" className="mr1" />}
                text={ t('pageReport_saveBtn') }
                type='submit'
                onClick={() => {
                  if (modalData.data.isHead) {
                    saveTechnicalError()
                  } else {
                    save();
                  }
                }}
                disabled={!canSave || (!modalData.data.isHead && causeCode === 'TECHNICAL_ERROR')}
              />
            </Box>

          </>
        }
        {
          modalData.data.isVisited === true &&
          <>
            <Box className='flex items-center mb2'>
              <Typography children={t('pageReport_scanTime')} style={{width: '50%'}} />
              <Typography children={moment(modalData.data?.visitingTime).format('YYYY-MM-DD HH:mm:ss')} style={{width: '50%'}} />
            </Box>
            <Box className='flex items-center mb2'>
              <Typography children={t('pageReport_markedRole')} style={{width: '50%'}} />
              { modalData.data?.personWhoMarkedRole === ROLES.SELF && <Typography children={t('pageReport_self')} style={{width: '50%'}} /> }
              { modalData.data?.personWhoMarkedRole === ROLES.PRESCHOOL_TEACHER && <Typography children={t('pageReport_preschoolTeacher')} style={{width: '50%'}} /> }
              { modalData.data?.personWhoMarkedRole === ROLES.PARENT && <Typography children={t('pageReport_parent')} style={{width: '50%'}} /> }
              { modalData.data?.personWhoMarkedRole === ROLES.ATTENDANT && <Typography children={t('pageReport_attendant')} style={{width: '50%'}} /> }
              { modalData.data?.personWhoMarkedRole === ROLES.ADMIN && <Typography children={t('pageReport_admin')} style={{width: '50%'}} /> }
            </Box>
            <Box className='flex items-center mb2'>
              <Typography children={t('pageReport_fullNameMarked')} style={{width: '50%'}} />
              <Typography children={modalData.data?.personWhoMarkedFullname} style={{width: '50%'}} />
            </Box>
            <Box className='flex items-center mb2'>
              <Typography children={t('pageReport_markingMethod')} style={{width: '50%'}} />
              {
                modalData.data?.markingMethod === 'BUTTON' &&
                  <Typography children={t('pageReport_buttonQRCode')} style={{width: '50%'}} />
              }
              {
                modalData.data?.markingMethod === 'QR' &&
                  <Typography children={t('pageReport_QRCode')} style={{width: '50%'}} />
              }
              {
                modalData.data?.markingMethod === 'FACE_RECOGNITION' &&
                  <Typography children={t('pageReport_faceRecognition')} style={{width: '50%'}} />
              }
              {
                modalData.data?.markingMethod === 'MANUAL' &&
                <Typography children={t('pageReport_manual')} style={{width: '50%'}} />
              }
            </Box>
          </>
        }
      </DialogContent>
    </Modal>
  );
}
